<template>
  <div>
    <div v-if="isBattery">
      <h5 v-dynamic-content:generic_package_information_title></h5>
      <p
        v-dynamic-content:generic_package_information_text1="
          substitutions.generic_package_information_text1
        "
      ></p>
      <p
        v-if="showSelfConsumption"
        v-dynamic-content:generic_package_information_text2="
          substitutions.generic_package_information_text2
        "
      ></p>
    </div>
    <div v-else>
      <h5 class="font-weight-bold" v-dynamic-content:pv_package_information_title></h5>
      <p
        v-if="amountOfQuotes === 1 && quote.hasSunsure"
        v-dynamic-content:pv_package_information_text1_singleoffer="
          substitutions.pv_package_information_text1_singleoffer
        "
      ></p>
      <p
        v-else-if="amountOfQuotes === 1"
        v-dynamic-content:pv_package_information_text1_singleoffer_no_sunsure="
          substitutions.pv_package_information_text1_singleoffer
        "
      ></p>
      <p
        v-else
        v-dynamic-content:pv_package_information_text1="substitutions.pv_package_information_text1"
      ></p>

      <p
        v-if="quote.hasSunsure"
        v-dynamic-content:pv_package_information_text2="substitutions.pv_package_information_text2"
      ></p>
      <p
        v-else
        v-dynamic-content:pv_package_information_text2_no_sunsure="
          substitutions.pv_package_information_text2
        "
      ></p>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: ['quote'],
  name: 'CardIntro',
  computed: {
    amountOfQuotes() {
      return this.quotes.length
    },
    ...mapGetters(['isGeneric', 'isBattery', 'iquote']),
    substitutions() {
      const { filters } = this.$options
      const {
        batteryCapacity,
        batterySelfConsumption,
        directEnergyUsagePercentage,
        savingsFirstYear,
        energyGenerated,
        annualSavings,
      } = this.quote.detailOverview

      const sumItemsPerType = (type) => {
        return this.quote.items
          .filter((i) => i.type === type)
          .reduce((acc, val) => acc + val.quantity, 0)
      }

      if (this.isBattery)
        return {
          generic_package_information_text1: [
            filters.formatKwh(batteryCapacity, 1),
            sumItemsPerType('battery'),
            sumItemsPerType('inverter'),
          ],
          generic_package_information_text2: [
            filters.formatKwh(this.iquote.energyConsumption),
            filters.formatPercentage(batterySelfConsumption),
            filters.formatPercentage(directEnergyUsagePercentage),
          ],
        }
      else
        return {
          pv_package_information_text1_singleoffer: [
            filters.formatKwp(this.quote.panelSumPowerKwp),
            this.quote.panels.quantity,
          ],
          pv_package_information_text1: [
            filters.formatKwp(this.quote.panelSumPowerKwp),
            this.quote.panels.quantity,
          ],
          pv_package_information_text2: [
            filters.formatCurrency(savingsFirstYear || annualSavings[0]),
            filters.formatKwh(energyGenerated[0]),
            filters.formatPercentage(this.quote.detailOverview.coverage * 100),
          ],
        }
    },
    showSelfConsumption() {
      const { batterySelfConsumption, directEnergyUsagePercentage } = this.quote.detailOverview
      return batterySelfConsumption && directEnergyUsagePercentage
    },
  },
}
</script>
